import { LoadScreen } from "./LoadScreen";

export class SplashScreen extends LoadScreen {
    public static readonly NAME: string = "Load_Splash";
}
